// initial state
const state = () => ({
  isMobile: false,
  enable: {
    notifications: true,
    push_notifications: true,
    guide: true,
    event_popup: true,
    cookie_consent: true,
    preferences_modal: true,
  }
});

// getters
const getters = {
  getIsMobile: state => {
    return state.isMobile;
  },
  getEnableNotifications: state => {
    return state.enable.notifications;
  },
  getEnablePushNotifications: state => {
    return state.enable.push_notifications;
  },
  getEnableGuide: state => {
    return state.enable.guide;
  },
  getEnableEventPopup: state => {
    return state.enable.event_popup;
  },
  getEnableCookieConsent: state => {
    return state.enable.cookie_consent;
  },
  getEnablePreferencesModal: state => {
    return state.enable.preferences_modal;
  },
};

// actions
const actions = {};

// mutations
const mutations = {
  setIsMobile: (state, is_mobile) => {
    state.isMobile = is_mobile;
    state.enable.notifications = !is_mobile;
    state.enable.push_notifications = !is_mobile;
    state.enable.guide = !is_mobile;
    state.enable.event_popup = !is_mobile;
    state.enable.cookie_consent = !is_mobile;
    state.enable.preferences_modal = !is_mobile;
  },
  setDisablePopups: (state) => {
    state.enable.notifications = false;
    state.enable.push_notifications = false;
    state.enable.guide = false;
    state.enable.event_popup = false;
    state.enable.cookie_consent = false;
    state.enable.preferences_modal = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
